module.exports = __webpack_public_path__ + "static/img/sustainability_program_04.0040c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_program_04.jpg
// module id = 4g2i
// module chunks = 0